import { Component, OnInit, AfterViewInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { Router } from '@angular/router';
import { User } from 'app/shared/models/User';
import { SharedService } from 'app/shared/services/shared.service';
import { CompanyAuditService } from 'app/company-audit/services/company-audit.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
//import { UserAuditService } from 'app/user-audit/services/user-audit.service';
import { MyAuditListModel } from 'app/user-audit/models/my-audit-list.model';
import { CompanyUserModel } from 'app/shared/models/company-user.model';
import { ICompanyAuditDetailsModel } from 'app/company-audit/models/company-audit-details.model';
import { CompanyAuditModuleViewModel } from 'app/company-audit/models/company-audit-module-view.model';
import { Result } from 'app/core/models/result';
import { ReportCompanyAuditModuleModel } from 'app/company-audit/models/report-company-audit-module';
import { ReportSelectorCompanies } from '../../../company-audit/models/report-selector-companies.model';
import { ReportSelectorUsers } from '../../../company-audit/models/report-selector-users.model';
import { ReportSelectorModules } from '../../../company-audit/models/report-selector-modules.model';
import { SummaryRating } from '../../../shared/models/summaryRating.model';
import * as moment from 'moment';
import { CompanyFilterSelected } from '../../../shared/models/company-filter-selected.model';
import { CookieService } from 'ngx-cookie-service';
import { CompanyAuditReportPeriodsViewModel } from '../../../company-audit/models/company-audit-report-periods.model';
import { ReportFiltersModel } from '../../../company-audit/models/report-filters.model';
import { AccountService } from '../../../core/services/account.service';

@Component({
    selector: 'app-user-dashboard',
    templateUrl: './user-dashboard.component.html',
    styleUrls: ['./user-dashboard.component.css']
})
export class UserDashboardComponent implements OnInit, AfterViewInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    userUrl: Router;
    user: User;
    isAdmin: boolean = false;
    companyUserList: CompanyUserModel[];
    managerCompanyUserList: CompanyUserModel[];
    managerNonACRCompanyUserList: CompanyUserModel[];
    filtersFormGroup: FormGroup;
    submitAttempt: boolean = false;

    audits: ICompanyAuditDetailsModel[] = [];
    rlAudits: ICompanyAuditDetailsModel[];
    rlAuditModules: CompanyAuditModuleViewModel[];
    gboAudits: ICompanyAuditDetailsModel[];
    gboAuditModules: CompanyAuditModuleViewModel[];
    //gboAuditModules: CompanyAuditModuleView[];

    resLendingAudits: ICompanyAuditDetailsModel[];
    genObligationAudits: ICompanyAuditDetailsModel[];
    resLendingAuditModules: ReportCompanyAuditModuleModel[];
    genObligationAuditModules: ReportCompanyAuditModuleModel[];

    overdueAudits: ICompanyAuditDetailsModel[];
    upcomingAudits: ICompanyAuditDetailsModel[];

    reportSelectorCompanies: ReportSelectorCompanies[];
    reportSelectorCompaniesTemp: ReportSelectorCompanies[];
    reportSelectorCompaniesFiltered: ReportSelectorCompanies[];
    reportSelectedCompany: string = 'All Companies';
    reportSelectorCompaniesChanged: boolean = false;

    reportSelectedCompanyTest: string = 'All Companies';
    tempCompanyExport: CompanyFilterSelected;


    reportSelectorUsers: ReportSelectorUsers[];
    reportSelectorUsersFiltered: ReportSelectorUsers[];
    reportSelectedUser: string = 'All Users';

    reportRating: number = null;
    reportRatingLabel: string = 'All Ratings';

    reportSelectorModules: ReportSelectorModules[];
    reportSelectedModule: string = 'All Modules';

    auditReportPeriods: CompanyAuditReportPeriodsViewModel[] = [];

    // Passed into Charts
    summaryRatingList: SummaryRating[] = [];
    summaryCompletedList: SummaryRating[] = [];
    showCompletedChart: boolean = false;
    showRatingsChart: boolean = false;
    //resLendingAuditsComplete: number;
    resLendingAuditsPerMonth: number;
    summaryAuditsPerMonth: SummaryRating[] = [];
    summaryDaysToComplete: SummaryRating[] = [];
    summaryRatingsPerMonth: any[] = [];
    summaryAuditsPerBroker: SummaryRating[] = [];

    reportFiltersModel: ReportFiltersModel;

    dateWarningsText: string;
    dateWarningsCount: number = 0;
    dateAlertsText: string;
    dateAlertsCount: number = 0;

    companyTree: string;

    today: Date = new Date();
    oneMonth: Date = new Date(new Date().setMonth(new Date().getMonth() + 1));
    endDate: Date;
    startDate: Date;
    testDate: Date;
    showGbo: boolean = false;

    positiveMinVal: number = 0;
    positiveMaxVal: number = 0.25;
    okMinVal: number = 0.2501;
    okMaxVal: number = 0.7500;
    highRiskMinVal: number = 0.7501;
    hghRiskMaxVal: number = 10.00;


    // use for paged loading
    showRLRows: boolean = false;

    config: {
        suppressScrollX: true
    }


    constructor(
        private accountService: AccountService,
        private sharedService: SharedService,
        private companyAuditService: CompanyAuditService,
        private fb: FormBuilder,
        private cookieService: CookieService
    ) {
    }

    ngOnInit() {

        this.accountService.getUser().subscribe(
            user => {
                this.user = user;
                this.isAdmin = user.isAdmin;
                this.accountService.getCompanyUser().subscribe(companyUser => {
                    this.companyUserList = companyUser;

                    this.managerCompanyUserList = this.companyUserList.filter(x => x.userTypeId == 2);
                    this.managerNonACRCompanyUserList = this.companyUserList.filter(x => x.userTypeId == 2 && x.companyTypeId > 1);
                    this.audits = [];
                    this.companyUserList.forEach(x => {
                        if (x.siteUserId) {
                            this.companyAuditService.getAll(x.companyId).subscribe(
                                audits => {
                                    this.audits = this.audits.concat(audits);
                                    this.rlAudits = audits.filter(x => x.auditTemplateId == 'ea22f683-0baa-4ff4-8fa2-ed374fec2f43');

                                    this.gboAudits = audits.filter(x => x.auditTemplateId == 'ce2faee3-7ccc-45dc-82ba-6af7301d6f06');
                                    this.gboAudits.forEach(a => {
                                        this.companyAuditService.getAuditModules(a.id).subscribe(
                                            modules => {
                                                this.gboAuditModules = modules;
                                            },
                                            error => {
                                                this.errors = (<Result>error).errorList;
                                            });
                                    })

                                },
                                error => this.errors = error.errorList
                            );
                        }
                    })

                    this.headerTitle = { title: 'Dashboard' };

                    // Get Modules
                    this.companyAuditService.reportAvailableModules().subscribe(
                        modules => {
                            this.reportSelectorModules = modules.filter(x => x.auditCategoryId == 1);
                            // Get Companies
                            this.companyAuditService.reportAvailableCompanies().subscribe(
                                companies => {
                                    this.reportSelectorCompanies = companies;
                                    if (companies.length == 1) {
                                        this.reportSelectedCompany = companies[0].companyName;
                                    }
                                    // Get Users
                                    this.companyAuditService.reportAvailableUsers().subscribe(
                                        users => {
                                            this.reportSelectorUsers = users;
                                            this.reportSelectorUsersFiltered = users;
                                            if (users.length == 1) {
                                                this.reportSelectedUser = users[0].firstName + ' ' + users[0].lastName;
                                            }
                                            // Init Filters
                                            this.initFilters();
                                        },
                                        error => this.errors = error.errorList
                                    );
                                },
                                error => this.errors = error.errorList
                            );
                        },
                        error => this.errors = error.errorList
                    );
                });
            },
            error => this.errors = error.errorList
        );


    }

    ngAfterViewInit() {

    }

    initFilters() {

        // Check to see if cookie exists
        if (this.cookieService.check('c365-filters')) {

            // Cookie exists, populate form with cookie values
            const cookieValue: string = this.cookieService.get('c365-filters');

            const cookieFilters = JSON.parse(cookieValue);

            this.startDate = new Date(cookieFilters.startDate);
            this.endDate = new Date(cookieFilters.endDate);

            this.filtersFormGroup = this.fb.group(
                {
                    startDate: [this.startDate, Validators.required],
                    endDate: [this.endDate, Validators.required],
                    auditCategoryId: [cookieFilters.auditCategoryId],
                    siteUserId: [this.user.id, Validators.required],
                    companyId: [cookieFilters.companyId],
                    excludeDownstream: [cookieFilters.excludeDownstream],
                    auditUserId: [cookieFilters.auditUserId],
                    moduleId: [cookieFilters.moduleId],
                    reportRating: [cookieFilters.reportRating]
                }
            );

        } else {

            // Cookie does not exist, populate form with default values
            this.endDate = new Date();
            this.startDate = new Date();
            this.startDate.setFullYear(this.endDate.getFullYear() - 1);

            this.filtersFormGroup = this.fb.group(
                {
                    startDate: [this.startDate, Validators.required],
                    endDate: [this.endDate, Validators.required],
                    auditCategoryId: [''],
                    siteUserId: [this.user.id, Validators.required],
                    companyId: [null],
                    excludeDownstream: [false],
                    auditUserId: [null],
                    moduleId: [''],
                    reportRating: [null]
                }
            );

        }


        this.updateFilters();
    }

    updateFilters() {

        this.submitAttempt = true;

        const formValue = this.filtersFormGroup.value;

        // Companies
        if (formValue.companyId && this.reportSelectorCompanies) {



            // Selected and inherited companies
            // Used to display only users for selected companies
            if (formValue.excludeDownstream) {
                this.reportSelectorCompaniesFiltered = this.reportSelectorCompanies.filter(x => x.companyId == formValue.companyId);
            } else {
                // selected company
                this.reportSelectorCompaniesFiltered = this.reportSelectorCompanies.filter(x => x.companyId == formValue.companyId);
                // direct children of selected company
                var childCompanies: ReportSelectorCompanies[] = this.reportSelectorCompanies.filter(x => x.parentId == formValue.companyId);
                // grandchildren of selected company
                var grandchildCompanies: ReportSelectorCompanies[] = [];
                childCompanies.forEach(function (x) {
                    grandchildCompanies.push(this.reportSelectorCompanies.filter(y => y.parentId == x.companyId));
                }.bind(this));

                this.reportSelectorCompaniesFiltered = this.reportSelectorCompaniesFiltered.concat(childCompanies, grandchildCompanies[0]);
            }

            if (this.reportSelectorCompanies.length > 1) {
                this.reportSelectedCompany = this.reportSelectorCompanies.find(x => x.companyId == formValue.companyId).companyName;
                // filter users based on selected company and inherited companies
                this.reportSelectorUsersFiltered = [];
                this.reportSelectorCompaniesFiltered.forEach(function (x) {
                    if (x) {
                        this.reportSelectorUsersFiltered = this.reportSelectorUsersFiltered.concat(this.reportSelectorUsers.filter(y => y.companyId == x.companyId));
                    }
                }.bind(this));
            }
        } else if (!formValue.companyId && this.reportSelectorCompanies) {
            if (this.reportSelectorCompanies.length > 1) {
                this.reportSelectedCompany = 'All Companies';
                this.reportSelectorUsersFiltered = this.reportSelectorUsers;
            }
        }

        // Users
        if(this.reportSelectorCompaniesChanged) {
            formValue.auditUserId = null;
            this.filtersFormGroup.patchValue({ 'auditUserId': null });
        }

        if (formValue.auditUserId && this.reportSelectorUsers) {
            if (this.reportSelectorUsers.length > 1) {
                let u = this.reportSelectorUsers.find(x => x.companyUserId == formValue.auditUserId);
                this.reportSelectedUser = u.firstName + ' ' + u.lastName;
            }
        } else if (!formValue.auditUserId && this.reportSelectorUsers) {
            if (this.reportSelectorUsers.length > 1) {
                this.reportSelectedUser = 'All Users';
            }
        }

        // Dates
        var startDateObj = <HTMLInputElement>document.getElementById("startDate");
        if (startDateObj) {
            formValue.startDate = new Date(startDateObj.value);
            this.startDate = formValue.startDate;
        }

        var endDateObj = <HTMLInputElement>document.getElementById("endDate");
        if (endDateObj) {
            formValue.endDate = new Date(endDateObj.value);
            this.endDate = formValue.endDate;
        }

        if (formValue.reportRating == null) {
            this.reportRatingLabel = "All Ratings";
        }
        if (formValue.reportRating == 1) {
            this.reportRatingLabel = "Positive";
        }
        if (formValue.reportRating == 2) {
            this.reportRatingLabel = "OK";
        }
        if (formValue.reportRating == 3) {
            this.reportRatingLabel = "High Risk";
        }

        // Modules
        if (formValue.moduleId && this.reportSelectorModules) {
            if (this.reportSelectorModules.length > 1) {
                let m = this.reportSelectorModules.find(x => x.moduleId == formValue.moduleId);
                this.reportSelectedModule = m.moduleName;
            }
        } else if (!formValue.moduleId && this.reportSelectorModules) {
            if (this.reportSelectorModules.length > 1) {
                this.reportSelectedModule = 'All Modules';
            }
        }
        this.reportSelectorCompaniesChanged = false;


        this.cookieService.set('c365-filters', JSON.stringify(formValue), { expires: 7, sameSite: 'Lax' });


        this.getAudits();
    }

    updateCompanyFilter(companyId) {
        this.filtersFormGroup.value.companyId = companyId;
        this.updateFilters();
    }


    getAudits = () => {
        if (this.filtersFormGroup.valid) {
            this.showCompletedChart = false;
            this.showRatingsChart = false;
            const resLendingFilters = Object.assign({},this.filtersFormGroup.value);

            // Responsible Lending Category
            resLendingFilters.auditCategoryId = 1;
            resLendingFilters.moduleId = resLendingFilters.moduleId == '' ? null : resLendingFilters.moduleId;

            this.companyAuditService.reportCompanyAuditModules(resLendingFilters).subscribe(
                modules => {
                    this.resLendingAuditModules = modules;
                    // filter by rating
                    if (resLendingFilters.reportRating) {
                        let minVal: number = 0;
                        let maxVal: number = 1000;
                        if (resLendingFilters.reportRating == 1) {
                            minVal = 0;
                            maxVal = 0.25;
                        }
                        if (resLendingFilters.reportRating == 2) {
                            minVal = 0.2501;
                            maxVal = 0.7500;
                        }
                        if (resLendingFilters.reportRating == 3) {
                            minVal = 0.7501;
                            maxVal = 10.00;
                        }
                        this.resLendingAudits = this.convertReportingModulesToCompanyAudit(modules).filter(x => (x.rating / x.modulesCount) > minVal && (x.rating / x.modulesCount) < maxVal && x.auditStatus === 1);
                        this.resLendingAuditsRatingFn();
                        this.resLendingAuditsCompleteFn();
                        this.resLendingAuditsPerMonthFn(resLendingFilters, this.resLendingAudits);
                        this.resLendingDaysToCompletePerMonthFn();
                        this.resLendingAuditModulesPerBrokerFn();
                        //this.resLendingAuditsPerMonth = this.resLendingAuditsPerMonthFn(formValue, this.resLendingAudits.filter(x => (x.rating / x.modulesCount) > minVal && (x.rating / x.modulesCount) < maxVal && x.auditStatus === 1));
                        this.getOverdueAudits();
                        this.getUpcomingAudits();
                        this.getDateWarnings();
                    } else {
                        this.resLendingAudits = this.convertReportingModulesToCompanyAudit(modules);
                        this.resLendingAuditsRatingFn();
                        this.resLendingAuditsCompleteFn();
                        this.resLendingAuditsPerMonthFn(resLendingFilters, this.resLendingAudits);
                        this.resLendingDaysToCompletePerMonthFn();
                        this.resLendingAuditModulesPerBrokerFn();
                        //this.resLendingAuditsPerMonth = this.resLendingAuditsPerMonthFn(formValue, this.resLendingAudits);
                        this.getOverdueAudits();
                        this.getUpcomingAudits();
                        this.getDateWarnings();
                    }
                },
                error => this.errors = error.errorList
            );

            // GBO Category
            const genObFilters = Object.assign({},this.filtersFormGroup.value);
            genObFilters.auditCategoryId = 2;
            genObFilters.moduleId = genObFilters.moduleId == '' ? null : genObFilters.moduleId;

            this.companyAuditService.reportCompanyAuditModules(genObFilters).subscribe(
                modules => {
                    this.genObligationAudits = this.convertReportingModulesToCompanyAudit(modules);
                    this.genObligationAudits.forEach(a => {
                        this.companyAuditService.getAuditModules(a.id).subscribe(
                            modules => {
                                this.gboAuditModules = modules;
                                this.genObligationAudits.find(x => x.id == a.id).modules = modules;
                            },
                            error => {
                                this.errors = (<Result>error).errorList;
                            });
                    })
                },
                error => this.errors = error.errorList
            );

            this.getOverdueAudits();
        }
    }

    // iterates through modules and groups them by companyaudit whilst aggregating the scores
    convertReportingModulesToCompanyAudit = (modules: ReportCompanyAuditModuleModel[]) => {
        const tmpAuditList = <ICompanyAuditDetailsModel[]>([]);
        // loop through all loaded modules
        for (var i = 0; i < modules.length; i++) {
            // if tmpAudit is not empty
            if (tmpAuditList.length > 0) {
                var tmpAudit = tmpAuditList.find(x => x.id === modules[i].companyAuditId);
                // if a companyAudit already exists for this module, just add the score and the rating
                if (tmpAudit) {
                    let r = (modules[i].weightedScore / (modules[i].nrQuestions * 2))
                    tmpAudit.rating += isNaN(r) ? 100 : r;
                    tmpAudit.modulesCount++;
                }
                // if a corresponding audit doesn't already exist for this module
                else
                {

                    let r = (modules[i].weightedScore / (modules[i].nrQuestions * 2))

                    const newAudit = <ICompanyAuditDetailsModel>({
                        id: modules[i].companyAuditId,
                        companyName: modules[i].tradingName ? modules[i].tradingName : modules[i].legalName,
                        companyId: modules[i].companyId,
                        title: modules[i].companyAuditTitle,
                        auditTemplateId: modules[i].auditTemplateId,
                        auditTemplateDescription: modules[i].auditTemplateDescription,
                        startDate: modules[i].companyAuditStartDate ? new Date(modules[i].companyAuditStartDate) : null,
                        deadlineDate: modules[i].companyAuditDeadlineDate ? new Date(modules[i].companyAuditDeadlineDate) : null,
                        siteUserId: modules[i].auditUserId,
                        userName: modules[i].userName,
                        auditStatus: modules[i].companyAuditStatus,
                        completedDate: modules[i].companyAuditCompletedDate ? new Date(modules[i].companyAuditCompletedDate) : null,
                        isExternal: modules[i].isExternal,
                        reviewerSummary: modules[i].reviewerSummary,
                        reviewerSiteUserId: modules[i].reviewerSiteUserId,
                        customerSurname: modules[i].customerSurname,
                        customerInitial: modules[i].customerInitial,
                        lenderId: modules[i].lenderId,
                        lenderName: modules[i].lenderName,
                        aggregatorId: modules[i].aggregatorId,
                        aggregatorName: modules[i].aggregatorName,
                        modulesCount: 1,
                        rating: isNaN(r) ? 100 : r,
                        daysToComplete: modules[i].companyAuditCompletedDate ? this.daysDiff(moment(modules[i].companyAuditStartDate).toDate(), moment(modules[i].companyAuditCompletedDate).toDate()) : null

                    });
                    tmpAuditList.push(newAudit);
                }
            }
            // tmpAudit is empty (this is the first audit to be added)
            else
            {

                let r = (modules[i].weightedScore / (modules[i].nrQuestions * 2))
                const newAudit = <ICompanyAuditDetailsModel>({
                    id: modules[i].companyAuditId,
                    companyName: modules[i].tradingName ? modules[i].tradingName : modules[i].legalName,
                    companyId: modules[i].companyId,
                    title: modules[i].companyAuditTitle,
                    auditTemplateId: modules[i].auditTemplateId,
                    auditTemplateDescription: modules[i].auditTemplateDescription,
                    startDate: modules[i].companyAuditStartDate ? new Date(modules[i].companyAuditStartDate) : null,
                    deadlineDate: modules[i].companyAuditDeadlineDate ? new Date(modules[i].companyAuditDeadlineDate) : null,
                    siteUserId: modules[i].auditUserId,
                    userName: modules[i].userName,
                    auditStatus: modules[i].companyAuditStatus,
                    completedDate: modules[i].companyAuditCompletedDate ? new Date(modules[i].companyAuditCompletedDate) : null,
                    isExternal: modules[i].isExternal,
                    reviewerSummary: modules[i].reviewerSummary,
                    reviewerSiteUserId: modules[i].reviewerSiteUserId,
                    customerSurname: modules[i].customerSurname,
                    customerInitial: modules[i].customerInitial,
                    lenderId: modules[i].lenderId,
                    lenderName: modules[i].lenderName,
                    aggregatorId: modules[i].aggregatorId,
                    aggregatorName: modules[i].aggregatorName,
                    modulesCount: 1,
                    rating: isNaN(r) ? 100 : r,
                    daysToComplete: modules[i].companyAuditCompletedDate ? this.daysDiff(moment(modules[i].companyAuditStartDate).toDate(), moment(modules[i].companyAuditCompletedDate).toDate()) : null
                });
                tmpAuditList.push(newAudit);
            }
        }
        return tmpAuditList;
    }

    resLendingAuditsRatingFn = () => {

        // Create data for graph


        let totalAudits = this.resLendingAudits.length;
        let completedAudits = this.resLendingAudits.filter(x => x.auditStatus == 1).length;
        let positiveAudits = this.resLendingAudits.filter(x => (x.rating / x.modulesCount) > this.positiveMinVal && (x.rating / x.modulesCount) < this.positiveMaxVal && x.auditStatus === 1);
        let positivePercent = positiveAudits.length == 0 ? 0 : positiveAudits.length / completedAudits * 100;
        let okAudits = this.resLendingAudits.filter(x => (x.rating / x.modulesCount) > this.okMinVal && (x.rating / x.modulesCount) < this.okMaxVal && x.auditStatus === 1);
        let okPercent = okAudits.length == 0 ? 0 : okAudits.length / completedAudits * 100;
        let highRiskAudits = this.resLendingAudits.filter(x => (x.rating / x.modulesCount) > this.highRiskMinVal && (x.rating / x.modulesCount) < this.hghRiskMaxVal && x.auditStatus === 1);
        let highRiskPercent = highRiskAudits.length == 0 ? 0 : highRiskAudits.length / completedAudits * 100;


        this.summaryRatingList = [];

        let a = { "name": "Positive", "value": positivePercent }
        this.summaryRatingList.push(a);
        let b = { "name": "OK", "value": okPercent }
        this.summaryRatingList.push(b);
        let c = { "name": "High Risk", "value": highRiskPercent }
        this.summaryRatingList.push(c);

        this.showRatingsChart = true;

        this.resLendingAudits.filter(x => x.auditStatus == 1).forEach(x => {

        })

    }

    resLendingAuditsCompleteFn = () => {

        // Create data for graph

        let totalAudits = this.resLendingAudits.length;
        let completedAudits = this.resLendingAudits.filter(x => x.auditStatus == 1).length;
        let completedAuditsPercent = completedAudits / totalAudits * 100;

        this.summaryCompletedList = [];
        if (completedAudits == 0) {
            let a = { "name": "Completed", "value": 0 }
            this.summaryCompletedList.push(a);
            let b = { "name": "Not Completed", "value": 100 }
            this.summaryCompletedList.push(b);
        } else {
            let a = { "name": "Completed", "value": completedAuditsPercent }
            this.summaryCompletedList.push(a);
            let b = { "name": "Not Completed", "value": 100 - completedAuditsPercent }
            this.summaryCompletedList.push(b);
        }

        this.showCompletedChart = true;

    }


    resLendingAuditsPerMonthFn = (formValue, audits: ICompanyAuditDetailsModel[]) => {

        this.summaryAuditsPerMonth = [];
        this.summaryRatingsPerMonth = [];

        // set number of months
        let months = this.monthsDiff(formValue.startDate, formValue.endDate);

        // loop through months starting at earliest
        for (var i = months-1; i >= 0; i--) {

            var posCt = 0;
            var okCt = 0
            var negCt = 0;
            var month = moment(this.today).subtract(i, 'month').format('MMMM');
            var auditCount = 0;

            //loop through audits
            for (var x = 0; x < audits.length; x++) {
                // check for null dates
                if (audits[x].completedDate) {
                    // increment auditCount if audit was completed in that month
                    if (moment(this.today).subtract(i, 'month').isSame((moment(audits[x].completedDate).toDate()), 'month')) {
                        // Count audits for this month
                        auditCount++;
                        // Count Positive, OK, Negative audits for this month
                        if ((audits[x].rating / audits[x].modulesCount) > this.positiveMinVal && (audits[x].rating / audits[x].modulesCount) < this.positiveMaxVal && audits[x].auditStatus === 1) {
                            posCt++;
                        } else if ((audits[x].rating / audits[x].modulesCount) > this.okMinVal && (audits[x].rating / audits[x].modulesCount) < this.okMaxVal && audits[x].auditStatus === 1) {
                            okCt++;
                        } else if ((audits[x].rating / audits[x].modulesCount) > this.highRiskMinVal && (audits[x].rating / audits[x].modulesCount) < this.hghRiskMaxVal && audits[x].auditStatus === 1) {
                            negCt++;
                        }
                    }

                }
            }

            let y = { "name": month, "value": auditCount }
            this.summaryAuditsPerMonth.push(y);

            let m = {
                "name": month, "series": [
                    {
                        "name": "Positive", "value": posCt
                    },{
                        "name": "OK", "value": okCt
                    }, {
                        "name": "High Risk", "value": negCt
                    }]
            }
            this.summaryRatingsPerMonth.push(m);
        }
    }

    resLendingDaysToCompletePerMonthFn = () => {

        //this.summaryDaysToComplete = [{ "name": "10", "value": 4 }, { "name": "12", "value": 3 }, { "name": "15", "value": 6 }, { "name": "18", "value": 2 }, { "name": "11", "value": 5 }, { "name": "19", "value": 7 }, { "name": "30", "value": 4 }, { "name": "22", "value": 3 }, { "name": "25", "value": 6 }, { "name": "28", "value": 2 }, { "name": "21", "value": 5 }, { "name": "29", "value": 7 }, { "name": "10", "value": 4 }, { "name": "12", "value": 3 }, { "name": "15", "value": 6 }, { "name": "18", "value": 2 }, { "name": "11", "value": 5 }, { "name": "19", "value": 7 }, { "name": "50", "value": 4 }, { "name": "32", "value": 3 }, { "name": "35", "value": 6 }, { "name": "48", "value": 2 }, { "name": "31", "value": 5 }, { "name": "39", "value": 7 }];
        this.summaryDaysToComplete = [];

        for (var i = 0; i < this.resLendingAudits.length; i++) {
            // check for null dates
            if (this.resLendingAudits[i].completedDate) {
                // increment auditCount if audit was completed in that month
                var days = this.resLendingAudits[i].daysToComplete.toString();

                var objIndex = this.summaryDaysToComplete.findIndex((obj => obj.name == days));
                if (objIndex == -1) {
                    let a = { "name": days, "value": 1 }
                    this.summaryDaysToComplete.push(a);
                } else {
                    this.summaryDaysToComplete[objIndex].value = this.summaryDaysToComplete[objIndex].value + 1;
                }

            }
        }
    }

    resLendingAuditModulesPerBrokerFn = () => {
        this.summaryAuditsPerBroker = [];
        this.resLendingAuditModules.forEach(x => {
            if (x.brokerName) {
                var objIndex = this.summaryAuditsPerBroker.findIndex((obj => obj.name == x.brokerName));
                if (objIndex == -1) {
                    let a = { "name": x.brokerName, "value": 1 }
                    this.summaryAuditsPerBroker.push(a);
                } else {
                    this.summaryAuditsPerBroker[objIndex].value = this.summaryAuditsPerBroker[objIndex].value + 1;
                }
            }
        })
    }

    getOverdueAudits = () => {
        if (this.resLendingAudits) {
            this.overdueAudits = this.resLendingAudits.filter(x => x.siteUserId === this.user.id && x.auditStatus === 0 && x.deadlineDate < this.today);
        }
    }
    getUpcomingAudits = () => {
        if (this.resLendingAudits) {
            this.upcomingAudits = this.resLendingAudits.filter(x => x.siteUserId === this.user.id && x.auditStatus === 0 && x.deadlineDate > this.today && x.deadlineDate < this.oneMonth);
        }
    }
    getDateWarnings = () => {

        this.dateAlertsText = "Alert: ";
        this.dateWarningsText = "Warning: ";

        this.auditReportPeriods = [];

        this.managerCompanyUserList.forEach(x => {
            if (x.piExpiry < this.today) {
                this.dateAlertsCount++;
                this.dateAlertsText += "Your PI insurance is overdue. "
            }
            if (x.aclExpiry < this.today) {
                this.dateAlertsCount++;
                this.dateAlertsText += "Your ACL renewal is overdue. "
            }
            if (x.afcaExpiry < this.today) {
                this.dateAlertsCount++;
                this.dateAlertsText += "Your AFCA renewal is overdue. "
            }
            if (x.piExpiry > this.today && x.piExpiry < this.oneMonth) {
                this.dateWarningsCount++;
                this.dateWarningsText += "Your PI insurance is due in the next month. "
            }
            if (x.aclExpiry > this.today && x.aclExpiry < this.oneMonth) {
                this.dateWarningsCount++;
                this.dateWarningsText += "Your ACL renewal is due in the next month. "
            }
            if (x.afcaExpiry > this.today && x.afcaExpiry < this.oneMonth) {
                this.dateWarningsCount++;
                this.dateWarningsText += "Your AFCA renewal is due in the next month. "
            }
            this.getCompanyAuditReportPeriods(x.companyId);
        })
    }

    toggleGbo(): void {
        this.showGbo = !this.showGbo;
    }

    daysDiff = (d1, d2) => {
        var start = moment(d1);
        var end = moment(d2);
        return end.diff(start, "days")
    }

    monthsDiff = (d1, d2) => {
        let date1 = new Date(d1);
        let date2 = new Date(d2);
        let years = this.yearsDiff(d1, d2);
        let months = (years * 12) + (date2.getMonth() - date1.getMonth()
        );
        return months;
    }

    yearsDiff = (d1, d2) => {
        let date1 = new Date(d1);
        let date2 = new Date(d2);
        let yearsDiff = date2.getFullYear() - date1.getFullYear();
        return yearsDiff;
    }

    flatToHierarchy(flat) {

        var roots = [] // things without parent

        // make them accessible by guid on this map
        var all = {}

        flat.forEach(function (item) {
            all[item.companyId] = item
        })

        // connect childrens to its parent, and split roots apart
        Object.keys(all).forEach(function (companyId) {
            var item = all[companyId]
            if (item.treeLevel === 0) {
                roots.push(item)
            } else if (item.parentId in all) {
                var p = all[item.parentId]
                if (!('children' in p)) {
                    p.children = []
                }
                p.children.push(item)
            }
        })
        return roots
    }

    HTMLTree = function (jsonTree) {
        var retStr = '';
        for (var i = 0; i < jsonTree.length; i++) {
            retStr += '<li>' + jsonTree[i].companyName;
            if ((jsonTree[i].children) && (jsonTree[i].children.length > 0)) {
                retStr += '<ul>';
                for (var j = 0; j < jsonTree[i].children.length; j++)
                    retStr += this.HTMLTree(jsonTree[i].children);
                retStr += '</ul>';
            }
            retStr += '</li>';
        }
        retStr += '</ul>';
        return retStr;
    }

    getCompanies = () => {
        this.companyAuditService.reportAvailableCompanies().subscribe(
            companies => {
                this.reportSelectorCompanies = companies;
                if (companies.length == 1) {
                    this.reportSelectedCompany = companies[0].companyName;
                } else {
                    //this.companyTree = JSON.stringify(this.flatToHierarchy(companies));
                    //this.companyTree = this.HTMLTree(this.flatToHierarchy(companies));
                    //this.reportSelectorCompanies = this.flatToHierarchy(companies);
                }

            },
            error => this.errors = error.errorList
        );
    }


    getUsers = () => {
        this.companyAuditService.reportAvailableUsers().subscribe(
            users => {
                this.reportSelectorUsers = users;
                this.reportSelectorUsersFiltered = users;
                if (users.length == 1) {
                    this.reportSelectedUser = users[0].firstName + ' ' + users[0].lastName;
                }

            },
            error => this.errors = error.errorList
        );
    }

    getModules = () => {
        this.companyAuditService.reportAvailableModules().subscribe(
            modules => {
                this.reportSelectorModules = modules.filter(x => x.auditCategoryId==1);
            },
            error => this.errors = error.errorList
        );
    }

    getCompanySelected(companySelectedOutput: CompanyFilterSelected) {
        this.reportSelectorCompaniesChanged = true;
        this.filtersFormGroup.value.companyId = companySelectedOutput.companyId;
        // Make sure form is updated, not just model
        this.filtersFormGroup.patchValue({ 'companyId': companySelectedOutput.companyId });
        this.filtersFormGroup.patchValue({ 'excludeDownstream': companySelectedOutput.excludeDownstream });
    }

    getCompanyAuditReportPeriods = (companyId: string) => {
        this.companyAuditService.getCompanyAuditReportPeriods(companyId).subscribe(
            results => {
                var x = this.auditReportPeriods.findIndex((obj => obj.companyId == companyId));
                if (x == -1) {
                    this.auditReportPeriods = this.auditReportPeriods.concat(results);
                }
            },
            error => this.errors = error.errorList
        );
    }

    getType = (obj: any) => {
        return typeof obj;
    }

}
